import Head from 'next/head'
import Breadcrumbs from '@byma/shared/components/Breadcrumbs'
import useSWR from 'swr'
import { useRouter } from 'next/router'
import useAuth from '@byma/shared/hooks/useAuth'
import fetcher from '@byma/shared/helpers/fetcher'
import Link from 'next/link'
import Layout from 'components/Layout'
import PartnerForm from 'components/PartnerForm'
import PartnerItem from 'components/PartnerItem'
import Loader from '@byma/shared/components/Loader'
import { FiArrowLeftCircle } from 'react-icons/fi'

const breadcrumbPaths = [
    { label: 'Equipes', url: `/teams` },
]
export default function Partners() {

    const session = useAuth()
    const { query: { partnerId } } = useRouter()
    const { token, user: currentUser } = session

    const { data: partners, error } = useSWR(token ? ['/api/partners/getAll', null, token] : null, fetcher)

    const partnerSelected = partners && partners.result.find(partner => `${partner._id}`=== partnerId)


    function isAdmin(partner) {
        if (currentUser._id === partner.userId._id) {
            return true
        }
        const partnerUser = partner.users.find(u => u.userId._id === currentUser._id)
        if (partnerUser.level !== 'ADMIN') {
            return false
        }
        return true
    }

    return (
        <Layout {...{ session }}>
            <div className="flex divide-x-0 lg:divide-x h-full">
                <div className={`flex flex-col ${partnerSelected ? 'hidden lg:block' : 'lg:block'} w-full lg:w-1/2`}>
                    <div className="flex space-x-3 p-3 shadow w-full overflow-x-auto">
                        <Link href={`/teams/new`}>
                            <a>
                                <button className="btn-filters">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clipRule="evenodd" />
                                    </svg>
                                    <p>Nova equipe</p>
                                </button>
                            </a>
                        </Link>
                    </div>
                    <div className="p-3">
                        <Breadcrumbs paths={breadcrumbPaths} />
                    </div>
                    <div className="p-3">
                        {
                            partners ? (
                                <ul id="partner-list">
                                    {partners.result.map(partner => 
                                    <li> 
                                        <Link href={`/teams/${partner._id}`}>
                                            <a>
                                                <PartnerItem {...{partner, currentUser}} active={partnerSelected && partnerSelected._id === partner._id} />
                                            </a>
                                        </Link>
                                    </li>
                                    )}
                                </ul>
                            ) : (<Loader />)
                        }
                    </div>
                </div>
                <div className={`${!partnerSelected && 'hidden lg:block'} w-full lg:w-1/2 p-3`}>
                    { partnerSelected ? (
                        <div className="flex flex-1 h-full flex-col overflow-hidden">
                            <div className="mb-6">
                                <p className="text-xl font-bold">{partnerSelected.name}</p>
                            </div>
                            <div className="mb-6 box flex justify-between">
                                <div>
                                    <p className="text-md">Contrato</p>
                                    <p>{partnerSelected.activeContract}</p>
                                    <p className="text-sm">Expira em</p>
                                </div>
                            </div>
                            <div className="mb-6 box">
                                <div className="mb-6">
                                    <p className="text-md">Usuários</p>
                                </div>
                                <div className="overflow-y-auto h-64">
                                    { partnerSelected.users.length > 0 ? partnerSelected.users.map(({ userId: user, level }) => (
                                        <div className="border rounded-full px-2 py-1 flex mb-3 items-center">
                                            { user?.profile?.picture ? (
                                                <img src={user.profile.picture} className="w-12 h-12 rounded-full mr-3" />
                                            ) : (
                                                <div className="w-12 h-12 rounded-full bg-gray-400 mr-3" />
                                            ) }
                                            <p>{user.profile.name}</p>
                                        </div>
                                    )) : (
                                        <div className="flex flex-col items-center justify-center text-gray-400 h-full text-center px-12">
                                            Nenhum usuário adicionado
                                        </div>
                                    )}
                                </div>
                            </div>
                            { isAdmin(partnerSelected) ? (
                                <Link href={`/teams/${partnerSelected._id}/edit`}>
                                    <a>
                                        <div className="flex flex-col rounded hover:bg-gray-100 p-3 cursor-pointer">
                                            <p className="text-lg">Editar equipe</p>
                                            <p className="text-sm text-gray-700">Edite informa&ccedil;&otilde;es e adicione e remova usu&aacute;rios</p>
                                        </div>
                                    </a>
                                </Link>
                            ) : (

                                <div className="flex flex-col rounded hover:bg-gray-100 p-3 cursor-default">
                                    <p className="text-lg">Editar equipe</p>
                                    <p className="text-sm text-gray-700">Edite informa&ccedil;&otilde;es e adicione e remova usu&aacute;rios</p>
                                    <p className="text-sm text-gray-700 italic">Voc&ecirc; n&atilde;o tem permiss&otilde;es para editar esta equipe</p>
                                </div>
                            ) }

                        </div> 
                    ) : (
                        <div className="flex flex-col items-center justify-center text-gray-400 h-full text-center px-12">
                            <FiArrowLeftCircle size={48} className="mb-6" />
                            Selecione uma equipe  ao lado para visualizar seus detalhes
                        </div>
                    ) }
                </div>
            </div>
        </Layout>
    )
}
